module.exports = __webpack_public_path__ + "static/media/anadir_marca.9a081b71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MarkCall/anadir_marca.svg
// module id = 1806
// module chunks = 0